import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

// import * as commonActionCreators from '../../../actions/common';
let allActionCreators = Object.assign({});

class MensBandsSplash extends React.Component {

	static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

	constructor(props) {
    super(props);
    this.state = {

    };
	}

	componentDidMount() {
    document.title = 'Diamonds Direct';
    document.getElementsByTagName("META")[7].content="Shop our extensive selection of diamond engagement rings, wedding bands, and other jewelry online. See the Diamonds Direct Difference today!";
  }

  internalNav(page) {
    this.context.router.push('/' + page);
  }

	externalNav(page) {
    window.location.href = '/' + page;
  }

  openNew(page) {
    let win = window.open(page, '_blank');
    win.focus();
  }

	render() {
		return <div className='MensBandsSplash'>
      <div className='mbTopSection'>
        <div className='topPromptWrapper'>
          <div className={'promptBox topPrompt'}>
            <div className='promptWrapper'>
              <div className='promptTitle'>Two-Tone Style</div>
              <div className='promptCopy'>Popular men's wedding bands include metals such as gold, platinum, and titanium. Choose a two-tone style to get everything you want in your forever piece.</div>
            </div>
            <div className='ringsWrapper'>
              <div className='ringItem'>
                <div className='ringItemImgWrapper'>
                  <img src='https://ddw2.diamondsdirect.com/img/gallery/bands/splash/mens/twotone_prod4.png' />
                </div>
                <div className='promptButton' onClick={() => this.internalNav('jewelry/B14TT01678')}>Shop This Ring</div>
              </div>
              <div className='ringItem'>
                <div className='ringItemImgWrapper'>
                  <img src='https://ddw2.diamondsdirect.com/img/gallery/bands/splash/mens/twotone_prod2.png' />
                </div>
                <div className='promptButton' onClick={() => this.internalNav('jewelry/B146M00541')}>Shop This Ring</div>
              </div>
              <div className='ringItem'>
                <div className='ringItemImgWrapper'>
                  <img src='https://ddw2.diamondsdirect.com/img/gallery/bands/splash/mens/twotone_prod3.png' />
                </div>
                <div className='promptButton' onClick={() => this.internalNav('jewelry/B14TT01362')}>Shop This Ring</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='mbBottomSection'>
        <div className={'bottomImgWrapper mobileBottomImgWrapper'}>
          <img src='https://ddw2.diamondsdirect.com/img/gallery/bands/splash/mens/vintage.jpg' />
        </div>
        <div className='bottomPromptWrapper'>
          <div className={'promptBox bottomPrompt'}>
            <div className='promptImg'>
              <img src='https://ddw2.diamondsdirect.com/img/gallery/bands/splash/mens/vintage_prod.png' />
            </div>
            <div className='promptWrapper'>
              <div className='promptTitle'>Vintage Style</div>
              <div className='promptCopy'>Celebrate your marriage with a wedding band that features intricate metal work created with milgrain and diamond accents for a vintage touch.</div>
              <div className='promptButton' onClick={() => this.internalNav('jewelry/BGD00830')}>Shop This Ring</div>
            </div>
          </div>
        </div>
        <div className={'bottomImgWrapper desktopBottomImgWrapper'}>
          <img src='https://ddw2.diamondsdirect.com/img/gallery/bands/splash/mens/vintage.jpg' />
        </div>
      </div>
		</div>;
	}
}
export default MensBandsSplash;

function mapStateToProps(state) {
  return {

  };
}

export const MensBandsSplashContainer = connect(
  mapStateToProps,
  allActionCreators
)(MensBandsSplash);


// WEBPACK FOOTER //
// ./src/components/views/gallery/blocks/splash/MensBandsSplash.jsx